"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.footerContext = exports.defaultFooterContext = exports.FooterProvider = void 0;
var _react = require("react");
const defaultFooterContext = exports.defaultFooterContext = {
  isMobileOffice: false,
  languages: [],
  paymentMethodsItems: [],
  copyrightLinks: [],
  siteLinksColumns: [],
  socialMediaLinks: []
};
const footerContext = exports.footerContext = /*#__PURE__*/(0, _react.createContext)(defaultFooterContext);
const FooterProvider = exports.FooterProvider = footerContext.Provider;